import React from 'react';
import { cookieUtil } from '@liepin/js-core4c-fe';
import { FrameworkHeader } from '@liepin/react-framework4c-pc';
import { needCheckCity } from '@liepin/react-framework4c-pc/src/modules/const';
import seoHydrate from '../../common/js/lib/seo-hydrate';

const city = (needCheckCity && cookieUtil.get('city_site')) || '';
const { adDqName = '' } = window.$CONFIG || {};

const $el = document.querySelector("#lp-seo-header-container");
$el && seoHydrate($el, <FrameworkHeader city={city} cityName={adDqName} isLogin={false} visibleCity />);


